/**
 * One tiny store for the route announcer: PageHeader announces its title on
 * mount, the live region in the shell reads it. document.title follows the
 * same call so screen reader and tab agree.
 */

import { useSyncExternalStore } from 'react';

let current = '';
const listeners = new Set<() => void>();

export function announce(title: string): void {
  current = title;
  document.title = `${title} . Beam portal`;
  for (const l of listeners) l();
}

/** Speak without renaming the tab: a tab change within a page. */
export function say(text: string): void {
  current = text;
  for (const l of listeners) l();
}

function subscribe(cb: () => void) {
  listeners.add(cb);
  return () => listeners.delete(cb);
}

export function useAnnouncement(): string {
  return useSyncExternalStore(subscribe, () => current, () => '');
}
